// const extend = require(`extend`);
const Q = require(`q`);
const _ = require(`underscore`);
// const moment = require(`moment`);

const __web_common_checkToken = require(`../../../data-service/default/web_common_checkToken`);

const web_common_checkToken = (pParameter) => {
    if (!pParameter) pParameter = {};
    return Q.when()
        .then(function () {
            return __web_common_checkToken({
                process_response_data: false,
            });
        })
        .then(function (data) {
            if (!data) {
                return Q.reject(data);
            }

            const code = data.code;
            if (code !== `000000`) {
                return Q.reject(data);
            }

            return Q.resolve(data);
        })
        // .catch(function (ex) {
        //     console.error(ex);
        //     if (ex) {
        //         if (ex.stack) {
        //             console.error(ex.stack);
        //         }
        //     }
        //     return Q.reject(ex);
        // })
        ;

};
module.exports = web_common_checkToken;
